import { useMemo, useState } from "react";

export default function QuickActionProjectModal({
  open,
  mode,
  loading,
  onClose,
  onSubmit,
}) {
  const [titel, setTitel] = useState("");
  const [omschrijving, setOmschrijving] = useState("");
  const [locatie, setLocatie] = useState("");
  const [startDate, setStartDate] = useState("");

  const isLocatie = mode === "locatie";
  const modalTitle = useMemo(
    () => (isLocatie ? "Locatie toevoegen" : "Nieuwe opdracht"),
    [isLocatie]
  );

  if (!open) return null;

  const handleSubmit = async (event) => {
    event.preventDefault();
    await onSubmit({
      titel,
      omschrijving,
      locatie,
      startDate,
    });
    setTitel("");
    setOmschrijving("");
    setLocatie("");
    setStartDate("");
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-5 shadow-xl">
        <h3 className="text-lg font-semibold text-slate-900">{modalTitle}</h3>
        <p className="mt-1 text-sm text-slate-500">
          Deze actie maakt een projectrecord aan gekoppeld aan de klant.
        </p>

        <form onSubmit={handleSubmit} className="mt-4 space-y-3">
          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Titel</label>
            <input
              value={titel}
              onChange={(event) => setTitel(event.target.value)}
              className="w-full rounded-lg border border-slate-200 px-3 py-2"
              placeholder={isLocatie ? "Bijv. Locatie Hoofdentree" : "Bijv. Periodiek onderhoud Q2"}
              required
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Locatie</label>
            <input
              value={locatie}
              onChange={(event) => setLocatie(event.target.value)}
              className="w-full rounded-lg border border-slate-200 px-3 py-2"
              placeholder="Adres / locatie"
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Omschrijving</label>
            <textarea
              value={omschrijving}
              onChange={(event) => setOmschrijving(event.target.value)}
              className="w-full rounded-lg border border-slate-200 px-3 py-2"
              rows={3}
              placeholder="Korte toelichting"
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Gewenste startdatum</label>
            <input
              type="date"
              value={startDate}
              onChange={(event) => setStartDate(event.target.value)}
              className="w-full rounded-lg border border-slate-200 px-3 py-2"
            />
          </div>

          <div className="flex justify-end gap-2 pt-2">
            <button type="button" onClick={onClose} className="rounded-lg border border-slate-200 px-4 py-2 text-sm" disabled={loading}>
              Annuleren
            </button>
            <button type="submit" className="rounded-lg bg-slate-900 px-4 py-2 text-sm text-white" disabled={loading}>
              {loading ? "Opslaan..." : "Opslaan"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
